import { FolderPrimaryListDto } from '@common/dto/folder/primary-list-dto';
import { HttpSuccessDto } from '@common/dto/http';
import client, { clientTransformed } from '@common/utils/rest';

export const getPedigreeFolders = (): Promise<Array<FolderPrimaryListDto>> => {
	return client({
    path: 'api/pedigree/loadPedigreeFolders',
    method: 'GET',
		params: {
      addPedCheck: true,
    },
  }).then((response: HttpSuccessDto<Array<FolderPrimaryListDto>>) => {
    return response.entity;
  });
};

export const checkPedigreeNameExists = (folderId: FolderPrimaryListDto['id'], pedigreeName: string):  Promise<boolean> => {
	return client({
    path: 'api/pedigree/checkPedigreeNameExists',
    method: 'GET',
		params: {
      folderId,
      pedigreeName,
    },
  }).then((response: HttpSuccessDto<boolean>) => {
    return response.entity;
  });
};

export type CreatePedigreeAndMoveToFolderParams = {
  pedigreeName: string;
  pedigreeFolderId: FolderPrimaryListDto['id'];
  familyId: string | number;
};

export const createPedigreeAndMoveToFolder = async (params: CreatePedigreeAndMoveToFolderParams) => {
	await clientTransformed({
    path: 'api/individuals/createPedigreeAndMoveToFolder',
    method: 'POST',
		entity: params,
  });
};

export const getPedigreeMembersCount = (pedigreeId: string): Promise<{ data: number }> => {
	return client({
    path: 'api/pedigree/membersCount',
    method: 'GET',
		params: {
      pedigreeId,
    },
  }).then((response: HttpSuccessDto<{ data: number }>) => {
    return response.entity;
  });
};
